<template>
  <v-btn v-if="isClient" icon small class="navigation-announce" @click="handleClick">
    <Icon name="bell-circle" size="lg" color="gray-0" class="site-header__icon" />
  </v-btn>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import Icon from '@/components/renewal/common/icon.vue';

declare global {
  interface Window {
    STANDSMotion?: {
      showIntro: () => void;
    };
  }
}

const isClient = ref(false);

onMounted(() => {
  isClient.value = true;
});

const handleClick = () => {
  window.STANDSMotion?.showIntro();
};
</script>

<style lang="scss" scoped src="./navigation-announce.scss"></style>
